import React, { useContext } from "react";
import { DataTable, ErrorBoundary, Page, hasActiveFilters, } from "@sscs/ui";
import { omit } from "lodash";
import { sbomID } from "../../../constants";
import { filterUpdated, initFilter, paginationUpdated, selectFilter, selectPagination, selectSort, sortUpdated, } from "../../../store/sbomSlice";
import { selectScrollTo } from "../../../store/sdlcReportSlice";
import { ReportContext } from "../../context";
import { useReportDispatch, useReportSelector, useScrollIntoView, } from "../../hooks";
import { useGetSoftwareListQuery } from "../../services/sbom.api";
import { useGetReportSummaryQuery } from "../../services/shared.api";
import { getQueryStatus } from "../../utils";
import XbomExportActions from "../common/XbomExportActions/XbomExportActions";
import Filter from "./Filter/Filter";
import SoftwareDetails from "./SoftwareDetails/SoftwareDetails";
const COLUMNS = [
    { id: "info", label: "Info", width: "70px" },
    {
        id: "issues",
        label: "Priority / # issues",
        sortProperty: "issues",
        sortId: "sbom-sort-issues",
        startReverse: true,
        width: "170px",
    },
    { id: "type", label: "Type", width: "240px" },
    {
        id: "product_name",
        label: "Name and version",
        sortProperty: "product_name",
        sortId: "sbom-sort-product-name",
        width: "25%",
    },
    {
        id: "publisher",
        label: "Publisher",
        sortProperty: "publisher",
        sortId: "sbom-sort-publisher",
        width: "25%",
    },
    {
        id: "license",
        label: "License",
        sortProperty: "license",
        sortId: "sbom-sort-license",
        width: "25%",
    },
    {
        id: "file_name",
        label: "File name",
        sortProperty: "file_name",
        sortId: "sbom-sort-file-name",
        width: "25%",
    },
];
const SBOMContent = () => {
    var _a;
    const { reportId, diffId } = useContext(ReportContext);
    const dispatch = useReportDispatch();
    const filter = useReportSelector(selectFilter);
    const sort = useReportSelector(selectSort);
    const scrollTo = useReportSelector(selectScrollTo);
    const pagination = useReportSelector(selectPagination);
    const { data: reportSummaryData } = useGetReportSummaryQuery({
        diff_report_id: diffId,
        ui_id: reportId,
    });
    const { data = { match_count: 0, software: [] }, isLoading, isFetching, isError, error, } = useGetSoftwareListQuery({ filter, sort, pagination, ui_id: reportId });
    useScrollIntoView(scrollTo, sbomID);
    const handleSortChange = (newSort) => {
        dispatch(sortUpdated(newSort));
    };
    return (React.createElement(Page.Root, { id: sbomID },
        React.createElement(Page.Header, { title: "Software bill of materials", details: [
                `${((_a = reportSummaryData === null || reportSummaryData === void 0 ? void 0 : reportSummaryData.counters.xbom.sbom) !== null && _a !== void 0 ? _a : 0).toLocaleString()} Components and dependencies`,
            ], actions: React.createElement(XbomExportActions, null) }),
        React.createElement(Page.Filters, { found: {
                id: "sbom-clear-all-filters",
                count: data.match_count,
                initialFilters: omit(initFilter, ["component_id", "dependency_id"]),
                activeFilters: omit(filter, ["component_id", "dependency_id"]),
                onClear: () => dispatch(filterUpdated(initFilter)),
            } },
            React.createElement(Filter, { filter: filter, onFilterChange: (filter) => dispatch(filterUpdated(filter)) })),
        React.createElement(Page.Body, null,
            React.createElement(DataTable, { columns: COLUMNS, sort: sort, onSortChange: handleSortChange, empty: {
                    subject: "software",
                    filters: {
                        active: hasActiveFilters(initFilter, filter),
                        onReset: () => dispatch(filterUpdated(initFilter)),
                    },
                }, status: getQueryStatus({
                    isLoading,
                    isFetching,
                    isError,
                    error,
                    data,
                }), pagination: {
                    id: "sbom-pagination",
                    itemCount: data.match_count,
                    pagination,
                    onChange: (pagination) => dispatch(paginationUpdated(pagination)),
                } }, data.software.map((software, index) => (React.createElement(SoftwareDetails, { key: software.identity.uuid, rowIndex: index, software: software })))))));
};
const SBOM = () => {
    return (React.createElement(ErrorBoundary, { key: "sbom" },
        React.createElement(SBOMContent, null)));
};
export default SBOM;
//# sourceMappingURL=SBOM.js.map